const MODULE_URL = 'view_files';
export default {
  MODULE_URL: MODULE_URL,
  SESSIONS_URL: MODULE_URL,

  SESSION_CREATED: 'view_file_added',
  SESSION_REMOVED: 'view_file_removed',
  SESSION_UPDATED: 'view_file_updated',

  FILE_DOWNLOADED: 'view_file_finished',
};
